import { Box } from "@mui/material";
import React from "react";
import ChooseSingleResponseBlock from "./ChooseSingleResponseBlock";
import useNodeContext from "../../hooks/useNodeContext";
import { isDefined } from "@convin/utils/helper/common.helper";
import NodeStatePorvider from "../../context/NodeStatePorvider";
import { NodeStateProviderProps } from "../../context/NodeStateContext";
import ConfigureSingleResponseBlockType from "../ConfigureSingleBlockType";

const CreateNode: React.FC = () => {
    const { state } = useNodeContext();
    return (
        <>
            <Box className="min-w-[450px] h-full">
                {isDefined(state.buildingBlockType) &&
                isDefined(state.selectedBlockType) ? (
                    <ConfigureSingleResponseBlockType />
                ) : (
                    <ChooseSingleResponseBlock />
                )}
            </Box>
        </>
    );
};

export default function CreateSingleResponseBlockType(
    props: NodeStateProviderProps
) {
    return (
        <NodeStatePorvider {...props}>
            <CreateNode />
        </NodeStatePorvider>
    );
}
